import { WebRequest } from 'framework-ui-components';

export const storico = id => WebRequest.get('/Dichiarazione/Storico', { id });

export const anniRegistrati = () => WebRequest.get('/Home/AnniRegistrati', { });
